<template>
    <BCol cols="12" :md="vsMd">
        <ValidationProvider #default="validationContext" :name="$t(vsName)" :rules="{regex:/^(?:[0-1]\d|2[0-3]):(?:[0-5]\d)(?::(?:[0-5]\d))?$/}">
         

            <!-- cambio -->
            <BFormGroup :label="$t(vsName)" :class="vsRequired == '' ? 'required-field' : ''">
            <BInputGroup  :label-for="encodeURIComponent(vsName).replace('%20','_').toLowerCase()" :class="vsRequired == '' ? 'required-field' : ''">
                        <BFormInput
                            @input="$emit('update:vsModel', $event)"
                            id="example-input"
                            :v-model="vsModel"
                            :value="vsModel"
                            type="text"
                            placeholder="HH:mm:ss"
                        ></BFormInput>
                        <BInputGroupAppend>
                            <BFormTimepicker
                            @input="$emit('update:vsModel', $event)"
                            :v-model="vsModel"
                            :value="vsModel"
                            button-only
                            right
                            button-variant="outline-primary"
                            locale="es"
                            aria-controls="example-input"
                            ></BFormTimepicker>
                            <BFormInvalidFeedback :state="getValidationState(validationContext)"> {{validationContext.errors[0]}} </BFormInvalidFeedback>
                        </BInputGroupAppend>
                    </BInputGroup>
                </BFormGroup>
        </ValidationProvider>
    </BCol>
</template>

<script>
import { BCol, BFormGroup, BFormInvalidFeedback, BInputGroup, BInputGroupAppend, BFormTimepicker, BFormInput, } from 'bootstrap-vue';
import { toRefs, watch, ref, onMounted, computed } from '@vue/composition-api';
import { ValidationProvider } from 'vee-validate';
import formValidation from '@core/comp-functions/forms/form-validation';

export default {
    components:{ ValidationProvider, BInputGroup, BInputGroupAppend, BFormTimepicker, BFormInput, BCol, BFormGroup,BFormInvalidFeedback },
    props: ['vsName', 'vsModel', 'vsMd', 'vsRules', 'vsRequired', 'vsMin', 'vsMax'],
    emit: ['update:vsModel'],
    setup(props, { emit }) {
        const { getValidationState } = formValidation()
        const { vsMin, vsModel, vsRules } = toRefs(props)
        const data=ref(null)

        // watch(vsModel, (newVal) => {
        //     emit('update:vsModel', newVal); // Emitir el evento para actualizar vsModel en el componente padre
        // });

        return {
            getValidationState,
            data
        }
    },
}
</script>

<style>

</style>